var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-date',{class:[_vm.classList, { _state_error: _vm.hasError }],attrs:{"aria-autocomplete":"off","id":_vm.id,"locale":_vm.locale,"value":_vm.dateModel},on:{"input":_vm.validateDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }